import React from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeftIcon } from 'lucide-react';
export function BrandBook() {
  const blues = [{
    name: 'blue-200',
    hex: '#BFDBFE',
    class: 'bg-blue-200'
  }, {
    name: 'blue-300',
    hex: '#93C5FD',
    class: 'bg-blue-300'
  }, {
    name: 'blue-400',
    hex: '#60A5FA',
    class: 'bg-blue-400'
  }, {
    name: 'blue-500',
    hex: '#3B82F6',
    class: 'bg-blue-500'
  }, {
    name: 'blue-600',
    hex: '#2563EB',
    class: 'bg-blue-600'
  }];
  const grays = [{
    name: 'gray-900',
    hex: '#111827',
    class: 'bg-gray-900'
  }, {
    name: 'gray-700',
    hex: '#374151',
    class: 'bg-gray-700'
  }, {
    name: 'gray-600',
    hex: '#4B5563',
    class: 'bg-gray-600'
  }, {
    name: 'gray-500',
    hex: '#6B7280',
    class: 'bg-gray-500'
  }, {
    name: 'gray-400',
    hex: '#9CA3AF',
    class: 'bg-gray-400'
  }, {
    name: 'gray-200',
    hex: '#E5E7EB',
    class: 'bg-gray-200'
  }, {
    name: 'gray-100',
    hex: '#F3F4F6',
    class: 'bg-gray-100'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-365">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-366">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-367">
          <div className="flex items-center gap-3" data-id="element-368">
            <Logo showText={false} size="sm" data-id="element-369" />
            <span className="text-sm font-medium text-gray-900" data-id="element-370">
              Obra Digital — Brand Book
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.location.reload();
        }} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-371">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-372" />
            Volver al sitio
          </a>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-373">
        {/* Logo Section */}
        <section data-id="element-374">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-375">Logo</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-376">
            Versiones del logo para diferentes contextos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-377">
            {/* Logo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-378">
              <Logo showText={true} size="lg" variant="dark" data-id="element-379" />
            </div>
            {/* Logo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-380">
              <Logo showText={true} size="lg" variant="light" data-id="element-381" />
            </div>
            {/* Isotipo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-382">
              <Logo showText={false} size="lg" variant="dark" data-id="element-383" />
            </div>
            {/* Isotipo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-384">
              <Logo showText={false} size="lg" variant="light" data-id="element-385" />
            </div>
          </div>

          {/* Size variants */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-386">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-387">
              Tamaños
            </p>
            <div className="flex items-end gap-10" data-id="element-388">
              <div className="text-center" data-id="element-389">
                <Logo showText={true} size="sm" variant="dark" data-id="element-390" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-391">sm</span>
              </div>
              <div className="text-center" data-id="element-392">
                <Logo showText={true} size="md" variant="dark" data-id="element-393" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-394">md</span>
              </div>
              <div className="text-center" data-id="element-395">
                <Logo showText={true} size="lg" variant="dark" data-id="element-396" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-397">lg</span>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-500" data-id="element-398">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-399">
              <span className="font-medium text-gray-700" data-id="element-400">Espacio mínimo</span>
              <p className="text-xs mt-1" data-id="element-401">
                Mantener al menos 1x el ancho del isotipo como margen.
              </p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-402">
              <span className="font-medium text-gray-700" data-id="element-403">No distorsionar</span>
              <p className="text-xs mt-1" data-id="element-404">
                Nunca estirar, rotar o cambiar los colores del logo.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-405" />

        {/* Color Palette */}
        <section data-id="element-406">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-407">Colores</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-408">
            Paleta de colores de la marca.
          </p>

          {/* Primary */}
          <div className="mb-8" data-id="element-409">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-410">
              Primario
            </p>
            <div className="flex items-start gap-4" data-id="element-411">
              <div className="w-24 h-24 rounded-xl bg-blue-600 shadow-sm" data-id="element-412" />
              <div data-id="element-413">
                <p className="font-semibold text-gray-900" data-id="element-414">Blue 600</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-415">#2563EB</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-416">bg-blue-600</p>
              </div>
            </div>
          </div>

          {/* Blue scale */}
          <div className="mb-8" data-id="element-417">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-418">
              Escala de azules
            </p>
            <div className="flex gap-3" data-id="element-419">
              {blues.map(color => <div key={color.name} className="text-center" data-id="element-420">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm`} data-id="element-421" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-422">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-423">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Gray scale */}
          <div className="mb-8" data-id="element-424">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-425">
              Escala de grises
            </p>
            <div className="flex gap-3" data-id="element-426">
              {grays.map(color => <div key={color.name} className="text-center" data-id="element-427">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm border border-gray-200`} data-id="element-428" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-429">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-430">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Dark background */}
          <div data-id="element-431">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-432">
              Fondo oscuro
            </p>
            <div className="flex items-start gap-4" data-id="element-433">
              <div className="w-24 h-24 rounded-xl bg-[#111827] shadow-sm" data-id="element-434" />
              <div data-id="element-435">
                <p className="font-semibold text-gray-900" data-id="element-436">Dark</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-437">#111827</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-438">bg-[#111827]</p>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-439" />

        {/* Typography */}
        <section data-id="element-440">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-441">Tipografía</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-442">
            Inter — La fuente principal de la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-443">
            <div data-id="element-444">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-445">
                H1 — text-4xl font-extrabold
              </span>
              <h1 className="text-4xl font-extrabold text-gray-900" data-id="element-446">
                Nunca más pierdas registro
              </h1>
            </div>
            <div data-id="element-447">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-448">
                H2 — text-3xl font-bold
              </span>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-449">
                Precio simple y transparente
              </h2>
            </div>
            <div data-id="element-450">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-451">
                H3 — text-2xl font-bold
              </span>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-452">
                El caos de la información
              </h3>
            </div>
            <div data-id="element-453">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-454">
                H4 — text-xl font-semibold
              </span>
              <h4 className="text-xl font-semibold text-gray-900" data-id="element-455">
                Así de simple
              </h4>
            </div>
            <hr className="border-gray-100" data-id="element-456" />
            <div data-id="element-457">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-458">
                Body — text-base text-gray-600
              </span>
              <p className="text-base text-gray-600" data-id="element-459">
                Centraliza todas las fotos de obra automáticamente desde
                WhatsApp. Sin apps nuevas, sin fricción.
              </p>
            </div>
            <div data-id="element-460">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-461">
                Small — text-sm text-gray-500
              </span>
              <p className="text-sm text-gray-500" data-id="element-462">
                Menos del 0,1% del presupuesto total de una obra promedio.
              </p>
            </div>
            <div data-id="element-463">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-464">
                Caption — text-xs text-gray-400
              </span>
              <p className="text-xs text-gray-400" data-id="element-465">
                © 2026 Obra Digital. Todos los derechos reservados.
              </p>
            </div>
          </div>

          {/* Font weights */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-200 p-8" data-id="element-466">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-467">
              Pesos de fuente
            </p>
            <div className="space-y-4" data-id="element-468">
              <div className="flex items-baseline gap-4" data-id="element-469">
                <span className="w-24 text-xs text-gray-400" data-id="element-470">400 Regular</span>
                <span className="font-normal text-gray-900" data-id="element-471">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-472">
                <span className="w-24 text-xs text-gray-400" data-id="element-473">500 Medium</span>
                <span className="font-medium text-gray-900" data-id="element-474">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-475">
                <span className="w-24 text-xs text-gray-400" data-id="element-476">600 Semibold</span>
                <span className="font-semibold text-gray-900" data-id="element-477">
                  Obra Digital
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-478">
                <span className="w-24 text-xs text-gray-400" data-id="element-479">700 Bold</span>
                <span className="font-bold text-gray-900" data-id="element-480">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-481">
                <span className="w-24 text-xs text-gray-400" data-id="element-482">
                  800 Extrabold
                </span>
                <span className="font-extrabold text-gray-900" data-id="element-483">
                  Obra Digital
                </span>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-484" />

        {/* Buttons */}
        <section data-id="element-485">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-486">Botones</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-487">
            Estilos de botones utilizados en la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-8" data-id="element-488">
            {/* Primary */}
            <div data-id="element-489">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-490">
                Primario
              </p>
              <div className="flex items-center gap-4" data-id="element-491">
                <button className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-492">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-493">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-494">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-495">
                bg-blue-600 text-white rounded-xl
              </p>
            </div>

            {/* Secondary */}
            <div data-id="element-496">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-497">
                Secundario
              </p>
              <div className="flex items-center gap-4" data-id="element-498">
                <button className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-499">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-500">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-501">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-502">
                border border-gray-300 text-gray-700 bg-white rounded-xl
              </p>
            </div>

            {/* Ghost */}
            <div data-id="element-503">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-504">
                Ghost / Texto
              </p>
              <div className="flex items-center gap-4" data-id="element-505">
                <button className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-506">
                  Enlace de texto
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-507">
                text-blue-600 hover:text-blue-700
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-508" />

        {/* Text Colors */}
        <section data-id="element-509">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-510">
            Grises de texto
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-511">
            Colores de texto para diferentes jerarquías.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-512">
            <div data-id="element-513">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-514">
                text-gray-900
              </span>
              <p className="text-gray-900" data-id="element-515">
                Texto principal, títulos y encabezados importantes.
              </p>
            </div>
            <div data-id="element-516">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-517">
                text-gray-700
              </span>
              <p className="text-gray-700" data-id="element-518">
                Texto secundario con buena legibilidad.
              </p>
            </div>
            <div data-id="element-519">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-520">
                text-gray-600
              </span>
              <p className="text-gray-600" data-id="element-521">
                Texto de cuerpo estándar para párrafos.
              </p>
            </div>
            <div data-id="element-522">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-523">
                text-gray-500
              </span>
              <p className="text-gray-500" data-id="element-524">
                Texto de apoyo y descripciones secundarias.
              </p>
            </div>
            <div data-id="element-525">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-526">
                text-gray-400
              </span>
              <p className="text-gray-400" data-id="element-527">
                Texto sutil, captions y metadatos.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-528" />

        {/* Spacing & Radius */}
        <section data-id="element-529">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-530">
            Espaciado y Bordes
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-531">
            Valores de espaciado y radio de borde comunes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-532">
            {/* Border radius */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-533">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-534">
                Border Radius
              </p>
              <div className="flex items-end gap-4" data-id="element-535">
                <div className="text-center" data-id="element-536">
                  <div className="w-12 h-12 bg-blue-100 rounded-md" data-id="element-537" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-538">
                    rounded-md
                  </span>
                </div>
                <div className="text-center" data-id="element-539">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg" data-id="element-540" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-541">
                    rounded-lg
                  </span>
                </div>
                <div className="text-center" data-id="element-542">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl" data-id="element-543" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-544">
                    rounded-xl
                  </span>
                </div>
                <div className="text-center" data-id="element-545">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl" data-id="element-546" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-547">
                    rounded-2xl
                  </span>
                </div>
                <div className="text-center" data-id="element-548">
                  <div className="w-12 h-12 bg-blue-100 rounded-full" data-id="element-549" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-550">
                    rounded-full
                  </span>
                </div>
              </div>
            </div>

            {/* Spacing */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-551">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-552">
                Padding
              </p>
              <div className="space-y-3" data-id="element-553">
                <div className="flex items-center gap-3" data-id="element-554">
                  <div className="bg-blue-600 p-2 rounded" data-id="element-555">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-556" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-557">p-2 (8px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-558">
                  <div className="bg-blue-600 p-4 rounded" data-id="element-559">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-560" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-561">p-4 (16px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-562">
                  <div className="bg-blue-600 p-6 rounded" data-id="element-563">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-564" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-565">p-6 (24px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-566">
                  <div className="bg-blue-600 p-8 rounded" data-id="element-567">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-568" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-569">p-8 (32px)</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center pt-8 pb-4" data-id="element-570">
          <p className="text-xs text-gray-400" data-id="element-571">
            Obra Digital Brand Book — Uso interno
          </p>
        </div>
      </main>
    </div>;
}